import axios from 'axios';
let api = {};
let obj = {};
// api.root_path = 'http://192.168.1.108:9801';    //本地服
// api.root_path2 = 'ws://192.168.1.108:9801';  
// api.root_path = 'http://47.105.222.231:9801';    //测试服
// api.root_path2 = 'ws://47.105.222.231:9801'; 
api.root_path = 'http://www.rzhrpark.com:8080';   //正式服
// api.root_path2 = 'ws://hrp.bat100.net.cn:8080'; 
localStorage.setItem('root_path',api.root_path);
// localStorage.setItem('root_path2',api.root_path2);
api.axios_instance = null;
// api.timeout = 5000,
api.axios = function (vm) {
  if (!api.axios_instance) {
    console.log('axios create');
    var instance = axios.create({
      baseURL: api.root_path,
      // timeout: api.timeout
    });
    var token ='';
    if(localStorage.getItem('token')){
      token = 'Bearer '+localStorage.getItem('token');
    }
    instance.defaults.headers.common['Authorization'] = token;

    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {
      // 在发送请求之前做些什么
      vm.$store.commit('updateLoadingStatus',true)
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });
    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      // 对响应数据做点什么
      vm.$store.commit('updateLoadingStatus',false)
      if (response.data.status==0) {
        return response.data;
      } else if(response.data.status == -1){
        layer.open({
            title: "提示信息",
            content: response.data.msg
        });
        return false;
      }

    }, function (error) {
      // 对响应错误做点什么
      console.log('error', error);
      // if (error.response.status == 400 || error.response.status == 401) {
      //   // vm.$router.push({
      //   //   name: 'login',
      //   //   replace: true,
      //   //   path: '/login'
      //   // });
      //   // vm.$vux.alert.show({
      //   //   title: '提示',
      //   //   content:'请重新登录',
      //   // })
      // }
      return Promise.reject(error);
    });
    api.axios_instance = instance;
  }
  return api.axios_instance;
};
api.setToken = function () {
  var token ='';
  if(localStorage.getItem('token')){
    token = 'Bearer '+localStorage.getItem('token');
  }
  api.axios_instance.defaults.headers.common['Authorization'] = token;
}

api.get = function (vm, url, params = {}) {
  return api.axios(vm).get(url, {
    params: params
  });
};
api.post = function (vm, url, data, params = {}) {
  return api.axios(vm).post(url, data, {
    params: params
  });
};
api.postForm = function (vm, url, data) {
  return api.axios(vm).post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data'},
   }
  );
};
api.put = function (vm, url, data, params = {}) {
  return api.axios(vm).put(url, data, {
    params: params
  });
};
api.delete = function (vm, url, params = {}) {
  return api.axios(vm).delete(url, {
    params: params
  });
};



obj.install = function (Vue, options) {
  Vue.prototype.$http = api
}
export default obj;



// WEBPACK FOOTER //
// ./src/api/api.js